export { default } from './ImpactesMarato';
